export default "__VITE_ASSET__DCrP3mV5__"